<div class="flex justify-end items-center">
  <button type="button" (click)="getLang('de')" class="get-language">
    <span class="germanFlag flag"></span>
  </button>
  <button type="button" (click)="getLang('en-us')" class="get-language">
    <span class="britishFlag flag"></span>
  </button>
</div>
